import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  makeStyles,
  Radio,
  FormControlLabel,
  Divider,
  useTheme
} from '@material-ui/core';
import {
  Sort as SortIcon,
  Schedule as TimeIcon,
  Message as MessageIcon,
  Person as PersonIcon,
  TrendingUp as ActivityIcon,
  Star as FavoriteIcon,
  ArrowUpward as AscIcon,
  ArrowDownward as DescIcon
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  sortButton: {
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  menuHeader: {
    padding: '8px 16px',
    backgroundColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark' 
      ? theme.palette.background.paper 
      : theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  sortOption: {
    padding: '4px 16px',
    '& .MuiListItemIcon-root': {
      minWidth: 36,
    }
  },
  directionOption: {
    padding: '4px 16px',
    '& .MuiFormControlLabel-root': {
      margin: 0,
      width: '100%',
    }
  }
}));

const ChatSortMenu = ({ 
  currentSort = 'updatedAt',
  currentDirection = 'desc',
  onSortChange 
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSortChange = (newSort, newDirection = currentDirection) => {
    if (onSortChange) {
      onSortChange(newSort, newDirection);
    }
    handleClose();
  };

  const sortOptions = [
    {
      value: 'updatedAt',
      label: 'Data da última mensagem',
      icon: TimeIcon,
      description: 'Ordena por quando foi recebida a última mensagem'
    },
    {
      value: 'createdAt',
      label: 'Data de criação',
      icon: TimeIcon,
      description: 'Ordena por quando o chat foi criado'
    },
    {
      value: 'title',
      label: 'Nome do chat',
      icon: MessageIcon,
      description: 'Ordena alfabeticamente pelo título'
    },
    {
      value: 'unreadCount',
      label: 'Mensagens não lidas',
      icon: ActivityIcon,
      description: 'Ordena pelo número de mensagens não lidas'
    },
    {
      value: 'participantCount',
      label: 'Número de participantes',
      icon: PersonIcon,
      description: 'Ordena pelo número de participantes'
    }
  ];

  const getSortIcon = (sortValue) => {
    const option = sortOptions.find(opt => opt.value === sortValue);
    const IconComponent = option?.icon || TimeIcon;
    return <IconComponent fontSize="small" />;
  };

  return (
    <>
      <Tooltip title="Ordenar chats">
        <IconButton 
          className={classes.sortButton}
          onClick={handleClick}
          color={currentSort !== 'updatedAt' ? 'primary' : 'default'}
        >
          <SortIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: { minWidth: 280 }
        }}
      >
        <div className={classes.menuHeader}>
          <Typography 
            variant="subtitle2" 
            style={{ 
              color: theme.palette.type === 'dark' || theme.palette.mode === 'dark' 
                ? theme.palette.text.primary 
                : theme.palette.text.secondary 
            }}
          >
            Ordenar chats por:
          </Typography>
        </div>

        {sortOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSortChange(option.value)}
            className={classes.sortOption}
            selected={currentSort === option.value}
          >
            <ListItemIcon>
              <option.icon fontSize="small" />
            </ListItemIcon>
            <ListItemText 
              primary={option.label}
              secondary={option.description}
            />
            {currentSort === option.value && (
              <Radio checked size="small" />
            )}
          </MenuItem>
        ))}

        <Divider />

        <div className={classes.menuHeader}>
          <Typography 
            variant="subtitle2" 
            style={{ 
              color: theme.palette.type === 'dark' || theme.palette.mode === 'dark' 
                ? theme.palette.text.primary 
                : theme.palette.text.secondary 
            }}
          >
            Direção:
          </Typography>
        </div>

        <MenuItem 
          className={classes.directionOption}
          onClick={() => handleSortChange(currentSort, 'desc')}
        >
          <FormControlLabel
            control={<Radio checked={currentDirection === 'desc'} size="small" />}
            label={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <DescIcon fontSize="small" style={{ marginRight: 8 }} />
                Mais recente primeiro
              </div>
            }
          />
        </MenuItem>

        <MenuItem 
          className={classes.directionOption}
          onClick={() => handleSortChange(currentSort, 'asc')}
        >
          <FormControlLabel
            control={<Radio checked={currentDirection === 'asc'} size="small" />}
            label={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <AscIcon fontSize="small" style={{ marginRight: 8 }} />
                Mais antigo primeiro
              </div>
            }
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ChatSortMenu;
